
import { createRef, useEffect, useState } from 'react';
import { H2,Text,Block,InputGroup,SelectIcon,Option,Input,Button,DataTable,DataTableRow,Accordion } from '@lidofinance/lido-ui';
import StakeIcon from './stakeIcons';
import { useEthers,useCall, useTokenAllowance,useEtherBalance,useTokenBalance } from "@usedapp/core";
import { Contract } from "@ethersproject/contracts";
import { ethers } from "ethers";
import {SliderContainerStyle, SliderHolderStyle, SliderOptionStyle,SliderStyle} from "./stakingStyles.js";
import BalanceViewer from "./balances";
import HistPerf from './histperf';
import { formatEther, parseEther } from '@ethersproject/units'
import { create } from '@mui/material/styles/createTransitions';


const unizapabi = [{"inputs":[{"internalType":"address","name":"_router","type":"address"},{"internalType":"address","name":"_WETH","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"tokenAmountOutMin","type":"uint256"},{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"uint256","name":"tokenInAmount","type":"uint256"}],"name":"beefIn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"tokenAmountOutMin","type":"uint256"}],"name":"beefInETH","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"withdrawAmount","type":"uint256"}],"name":"beefOut","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"withdrawAmount","type":"uint256"},{"internalType":"address","name":"desiredToken","type":"address"},{"internalType":"uint256","name":"desiredTokenOutMin","type":"uint256"}],"name":"beefOutAndSwap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"checkWETH","outputs":[{"internalType":"bool","name":"isValid","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"uint256","name":"fullInvestmentIn","type":"uint256"}],"name":"estimateSwap","outputs":[{"internalType":"uint256","name":"swapAmountIn","type":"uint256"},{"internalType":"uint256","name":"swapAmountOut","type":"uint256"},{"internalType":"address","name":"swapTokenOut","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"minimumAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}]
const ERC20abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]
const pairabi = [{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"}]
const routerabi = [{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"}]


// const NATIVE = 'WDOGE'
// const WETH = '0xB7ddC6414bf4F5515b52D8BdD69973Ae205ff101'
function feetopercent(fee){
    if(!fee){
        return 'error';
    }
    return (fee.toNumber()/100).toFixed(2)
}
var truncateDecimals = function (number, digits) {
    var multiplier = Math.pow(10, digits),
        adjustedNum = number * multiplier,
        truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

    return truncatedNum / multiplier;
}
function fixNumber(num,decimals){
    if(!num.includes('.')){
        return num;
    }
    var parts = num.toString().split('.');
    parts[1] = parts[1].substr(0,decimals)
    return parts.join('.')
}

const Staking = (props) => {

    const config = props.settings;
    const chainInfo = props.chainInfo;

    const { account, activateBrowserWallet,library, deactivate, error } = useEthers();

    const [currency,setCurrency] = useState(props.settings.depositCurrencies[0]);
    const [amountRaw,setAmount] = useState('');
    const [fee,setFee] = useState(0);
    const [lpOut,setLpOut] = useState(0);
    const [isStaking,setStaking] = useState(true);

    const iu = !!config.LP;
    var doubleLiq = iu&&!isStaking&&currency.includes('+')

    const isWant = iu&&config.vaultAddress==config.currencies[currency];
    
    var amount = (amountRaw==='0.0'||amountRaw==='')? ((isWant&&iu)?'0.000000000000001':'0.0001'):amountRaw;

    const toosmall = amount=='0.0001'||parseFloat(amount)<=0.000000000000001;

    const etherBalance = useEtherBalance(account);

    const { error: chefInfoError, value: chefInfo } =
        useCall({
            contract: new Contract(config.chef.address,config.chef.abi),
            method: "userInfo",
            args : [config.chefIndex,account]
        }) ?? {};

    const shareBalance = chefInfo?chefInfo[0]:0;
    
    var currencyBalance = useTokenBalance(isStaking?(currency==chainInfo.native?chainInfo.weth:config.currencies[currency]||chainInfo.weth):(window.scytheLock?window.scytheLock.address:chainInfo.weth), account);
    if(!isStaking){
        currencyBalance = shareBalance;
    }
    useEffect(function(){
        console.log('re-defaulting')
        setCurrency(props.settings.depositCurrencies[0]);
    },[props.settings])
    
    var maxAmmt = 0;
    if(etherBalance&&currencyBalance){
        if(!isStaking){
            maxAmmt = formatEther(currencyBalance.mul(config.sharemult))-0;
        }else if(currency==chainInfo.native){
            maxAmmt = formatEther(etherBalance)-0;
        }else {
            maxAmmt = ethers.utils.formatUnits(currencyBalance,config.tokenDecimals[currency]||18)-0;
        }
    }

    const { error: feeError, value: fees } =
        useCall({
            contract: new Contract(config.contract.address,config.contract.abi),
            method: isStaking?"buyback":"reflection",
        }) ?? {};
    const { error: pplsError, value: pricePerLockShare } =
        useCall({
            contract: new Contract(config.contract.address,config.contract.abi),
            method: "getPricePerFullShare",
        }) ?? {};
    

    const outEst = 1;
    const swapEst = 1;

    if(pricePerLockShare){
        console.log(ethers.utils.formatEther(pricePerLockShare[0]))
    }

    useEffect(function(){
        (async function(){
            
            return;
            var zapper = new ethers.Contract(config.ZapperHH.address,config.ZapperHH.abi,window.signer);
            // zapper.on("Transfer", (from, to, value, event) => {
            //     console.log({
            //         from: from,
            //         to: to,
            //         value: value.toString(),
            //         data: event
            //     });
            // });
            console.log('CS RESULT: ')
            var csresult = await zapper.callStatic.zapInLP(chainInfo.weth,config.vault,parseEther('1.0'),0,config.contract.address,0,{
                value:parseEther('1.0')
            });
            console.log('CS RESULT: /')
            console.log(csresult);


        })();
    },[])
    
    const useMin = false;


    console.log(amount,maxAmmt)
    const hasEnough = (etherBalance&&currencyBalance&&!toosmall)?(maxAmmt>0&&maxAmmt>=amount):true;

    function changeStaking(){
        console.log('changeStaking')
        setCurrency(!isStaking?config.depositCurrencies[0]:config.withdrawCurrencies[0]);
        setStaking(!isStaking)   
        setAmount('')
    }
    async function useMax(){
        if(!account){
            return;
        }
        if(isStaking){
            if(currency==chainInfo.native){
                setAmount(formatEther((await window.provider.getBalance(account)).sub(ethers.utils.parseEther('2'))))
            }else{
                const contract = new ethers.Contract(config.currencies[currency],config.contract.abi,window.signer);
                var max = ethers.utils.formatUnits((await contract.balanceOf(account)),config.tokenDecimals[currency]||18);
                setAmount(max);
            }
        }else{
            setAmount(formatEther((shareBalance).mul(config.sharemult)));
        }
    }

    const ref = createRef();

    async function stakeTokens(){
        console.log('staking ',currency,amount)
        if(!account){
            activateBrowserWallet();
            return;
        }
        try{
            //window.signer = library.getSigner();
            
            if(isStaking){
                window.changeAlert(true,{
                    title: 'Depositing '+currency,
                    subtitle: 'You are currently depositing '+amount+' '+currency,
                    body: 'Please approve the transactions in your metamask wallet as they come up',
                    icon:'loader'
                })
                await config.deposit(currency,amount,window.enter,window.scytheLock,account,useMin,chainInfo);
                window.changeAlert(true,{
                    title: 'Deposited '+currency,
                    subtitle: 'You have deposited '+amount+' '+currency,
                    body: '',
                    icon:'success'
                })
            }else{
                window.changeAlert(true,{
                    title: 'Withdrawing to '+currency,
                    subtitle: 'You are currently withdrawing '+amount+' Shares',
                    body: 'Please approve the transactions in your metamask wallet as they come up',
                    icon:'loader'
                })
                await config.withdraw(currency,amount,window.enter,window.scytheLock,account,useMin,chainInfo);
                window.changeAlert(true,{
                    title: 'Withdrew to '+currency,
                    subtitle: 'You have withdrawn '+amount+' Shares',
                    body: '',
                    icon:'success'
                })
            }
        } catch(e){
            if(e.code===4001&&window.changeAlert){
                window.changeAlert(true,{
                    title: 'Error',
                    subtitle: 'User denied transaction',
                    body: 'Please try again',
                    icon:'error'
                  })
            }else if(e.data&&e.data.message&&e.message.startsWith('incorrect nonce,')){
                window.changeAlert(true,{
                    title: 'Error',
                    subtitle: 'Nonce desync error',
                    body: 'Please make sure you are using the official dogechain RPC (https://rpc.ankr.com/dogechain). To update your configuration, please delete DogeChain from your metamask networks and let HellHound re-add it',
                    icon:'error'
                  })
                //https://rpc.dogechain.dog
            }else if(e.data&&e.data.message){
                window.changeAlert(true,{
                    title: 'Error',
                    subtitle: e.data.message,
                    body: 'Please try again',
                    icon:'error'
                  })
            }
            // throw the error as normal

            throw e;

            // console.log('error',e)
        }
    }
    var stats = [
        {
            title: isStaking?'$HLH Buyback Fee':'Reflection',
            value: (fees?feetopercent(fees[0]):'err')+'%',
        },
    ]
    

    const migrating = false;//config.name=='usd'&&isStaking;

    return (
      <>
        <div style={{textAlign:'center'}}>
            <H2 style={{marginBottom:'14px'}} color="text">{isStaking?"Deposit":"Withdraw"} {config.symbol}</H2>
            <h4 style={{marginBottom:'16px',color:"rgba(255, 255, 255, 0.8)",fontWeight:"500"}}>{config.desc}</h4>
            <SliderContainerStyle>
                <SliderHolderStyle onClick={changeStaking}>
                    <SliderStyle style={{"left":isStaking?'2px':'calc(100% - 152px)'}}></SliderStyle>
                    <SliderOptionStyle key='depositSlider'>
                        Deposit
                    </SliderOptionStyle>
                    <SliderOptionStyle key='withdrawSlider'>
                        Withdraw
                    </SliderOptionStyle>
                </SliderHolderStyle>
            </SliderContainerStyle>
            <Block  style={{padding:'0px 0px 0px 0px'}}>
                <BalanceViewer settings={config} chainInfo={chainInfo} />
            <Block color="accent" >
            
                <InputGroup fullwidth ref={ref} style={{marginBottom:'16px'}}>
                    <SelectIcon fullwidth
                        anchorRef={ref}
                        icon={<StakeIcon coin={currency} />}
                        onChange={function noRefCheck(event){
                            setAmount('');
                            setCurrency(event);
                            
                            // console.log(event)
                        }}
                        value={currency}
                    >
                        {
                            (isStaking?props.settings.depositCurrencies:props.settings.withdrawCurrencies).map((currency,index) => {
                                return <Option
                                        leftDecorator={<StakeIcon coin={currency} />}
                                        key={currency+'select'}
                                        value={currency}
                                        
                                        >
                                        {currency}
                                        </Option>
                            })
                        }
                    </SelectIcon>
                    <Input fullwidth
                        placeholder="Amount"
                        label={isStaking?"Amount":"Shares"}
                        rightDecorator={
                            <Button color="primary" onClick={useMax} size="xs" variant="translucent">
                                {(isStaking&&currency==chainInfo.native)?'Max-2':'Max'}
                            </Button>
                        }
                        value={amountRaw}
                        onChange={(event)=>{setAmount(event.target.value)}}
                    />
                </InputGroup>
                
                <Button disabled={(migrating)||(((!amount||toosmall)&&account)||!hasEnough)} style={{marginBottom:'16px'}} color={hasEnough?(migrating?"warning":"primary"):"error"} fullwidth size="md" variant="filled" onClick={stakeTokens}>
                    {(migrating)?('Migrating'):(account?((hasEnough)?(isStaking?"Deposit":"Withdraw"):'Insufficient Balance'):'Connect Wallet')}
                </Button>
                <div style={{marginBottom:'16px',textAlign:'left'}}>
                    <DataTable style={{display:''}}>
                        {stats.map(function(stat){
                            return (
                                <DataTableRow key={stat.title+'stat'} loading={!fees} title={stat.title} help={stat.help}>
                                    {/* !fees||!(outEst&&(swapEst||doubleLiq||isWant)&&amount) */}
                                    <Text color={stat.strong} size="xs" strong={!!stat.strong}>{stat.value}</Text>
                                </DataTableRow>
                            )
                        })}
                    </DataTable>
                </div>
                </Block>
            </Block>
            
        </div>
        {
            config.info.map(function(info){
                return (
                    <Accordion
                        style={{marginTop:'16px'}}
                        summary={info.summary}
                        key = {info.summary}
                    >
                        {info.details}
                    </Accordion> 
                )
            })
        }
        {
            (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')?(<Accordion
                style={{marginTop:'16px'}}
                summary={'Historical Performance'}
                key = {'histperf'}
            >
                <HistPerf config={config} />
            </Accordion> ):(<></>)
        }
        
      </>
    );
  }
  
  export default Staking;